import { render, staticRenderFns } from "./change_project.vue?vue&type=template&id=47cc6be7&scoped=true&"
import script from "./change_project.vue?vue&type=script&lang=js&"
export * from "./change_project.vue?vue&type=script&lang=js&"
import style0 from "./change_project.vue?vue&type=style&index=0&id=47cc6be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc6be7",
  null
  
)

export default component.exports